import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryExport = get('inventory.export');

export const getInventoryExportInProgress = createSelector(
  getInventoryExport,
  get('inProgress')
);

export const getInventoryExportPresignedUrl = createSelector(
  getInventoryExport,
  get('presignedUrl')
);

export const getIsFetchingInventoryExportPresignedUrl = createSelector(
  getInventoryExport,
  get('fetching')
);
